[
  "http://localhost:3000",
  "https://edi-github.netlify.app",
  "https://webchat.edi.dev.hollard.com.au",
  "https://webchat.edi.hollard.com.au"
]
